import { useStaticQuery, graphql } from "gatsby";
import React, { FC } from "react";

export const Footer: FC = () => {
  const data: Queries.FooterQuery = useStaticQuery(graphql`
    query Footer {
      strapiGlobalContent {
        footer_links_1 {
          id
          alt_text
          article {
            slug
          }
          url
          label
        }
        footer_links_2 {
          id
          alt_text
          article {
            slug
          }
          url
          label
        }
        Socials {
          id
          Social_media
          URL
        }
      }
    }
  `);

  const socials: { [key: string]: { image: string; alt: string } } = {
    facebook: { image: "/images/fb.png", alt: "facebook" },
    instagram: { image: "/images/ig.png", alt: "instagram" },
    twitter: { image: "/images/twitter.png", alt: "twitter" },
    youtube: { image: "/images/yt.png", alt: "youtube" },
    linkedin: { image: "/images/linkedin.png", alt: "linkedin" },
  };
  return (
    <div className="ml-[-1px] mr-[-1px] rounded-tl-xl rounded-tr-xl border-l border-r border-t text-m leading-6 lg:flex lg:border-none">
      <div className="flex items-center rounded-tl-xl rounded-tr-xl bg-white px-12 pt-12 lg:min-h-[10rem] lg:border-l lg:border-r lg:border-t lg:pb-5 lg:pl-12 lg:pr-24 lg:pt-3">
        <ul>
          {data.strapiGlobalContent?.footer_links_1 &&
            data.strapiGlobalContent.footer_links_1.map(
              (item) =>
                item && (
                  <li key={item.id}>
                    <a
                      href={
                        item.article
                          ? `/article/${item.article.slug}`
                          : item.url
                          ? item.url
                          : "#"
                      }
                      title={item.alt_text || ""}
                    >
                      {item.label}
                    </a>
                  </li>
                ),
            )}
        </ul>
      </div>
      <div className="flex flex-1 items-center  justify-between rounded-tl-xl rounded-tr-xl bg-white px-12 pt-3 lg:min-h-[10rem] lg:scale-x-[100.1%] lg:border-l lg:border-r lg:border-t lg:pb-5">
        <ul>
          {data.strapiGlobalContent?.footer_links_2 &&
            data.strapiGlobalContent.footer_links_2.map(
              (item) =>
                item && (
                  <li key={item.id}>
                    <a
                      href={
                        item.article
                          ? `/article/${item.article.slug}`
                          : item.url
                          ? item.url
                          : "#"
                      }
                      title={item.alt_text || ""}
                    >
                      {item.label}
                    </a>
                  </li>
                ),
            )}
        </ul>
        <ul className="hidden space-x-5 self-center lg:inline-flex">
          {data.strapiGlobalContent!.Socials &&
            data.strapiGlobalContent!.Socials.map((item) => {
              if (!item) return;
              if (!item.Social_media) return;
              if (!Object.hasOwn(socials, item.Social_media)) return;
              return (
                <a href={item.URL || "#"} key={item.id} target="_blank">
                  <img
                    className="h-14"
                    src={
                      socials[item.Social_media]
                        ? socials[item.Social_media].image
                        : ""
                    }
                    alt={
                      socials[item.Social_media]
                        ? socials[item.Social_media].alt
                        : ""
                    }
                  />
                </a>
              );
            })}
        </ul>
      </div>
      <div className="flex min-h-[10rem] items-center justify-between rounded-tl-xl rounded-tr-xl bg-white px-12 pb-5 pt-3 lg:mr-[-1px] lg:max-w-[16rem] lg:border-l lg:border-r lg:border-t">
        <ul className="flex space-x-5 lg:hidden">
          {data.strapiGlobalContent!.Socials &&
            data.strapiGlobalContent!.Socials.map((item) => {
              if (!item) return;
              if (!item.Social_media) return;
              if (!Object.hasOwn(socials, item.Social_media)) return;
              return (
                <a href={item.URL || "#"} key={item.id} target="_blank">
                  <img
                    className="w-10"
                    src={
                      socials[item.Social_media]
                        ? socials[item.Social_media].image
                        : ""
                    }
                    alt={
                      socials[item.Social_media]
                        ? socials[item.Social_media].alt
                        : ""
                    }
                  />
                </a>
              );
            })}
        </ul>
        <a href="/" className="ml-4 max-w-[150px] flex-1">
          <img className="w-full" src="/images/logo2.png" alt="lima" />
        </a>
      </div>
    </div>
  );
};
